export default "https://cdn-web.disco.co/slack-badge-01f0df508edb42cd30f01ead7b805726.png";